const HOME_QUERY = `
{
  homestats {
    s4xinsightsapi {
      latestDate
      overview {
        followers {
          delta
          total
          deltaPct
        }
        listeners {
          total
          deltaPct
        }
        streams {
          total
          deltaPct
        }
      }
      playlistCollection {
        dataList {
          uri
          listeners
          followers
          streams
          title
          thumbnailUrl
          isPersonalized
        }
      }
      recordingStatsTable {
        recordingStatsList {
          numListeners
          numStreams
          trackName
          trend
          trackUri
          pictureUri
          isDisabled
        }
      }
    }
    cards {
      cardsList {
        uuid
        resourceUri
        cardType
        cardSource
        notificationClass
        clickExpirationBuffer {
          day
          hour
          minute
          second
        }
        displayCard {
          header
          title
          subtitle
          callToAction {
            text
            url
          }
          headerType
          displayType
          fallbackImageUrl
          cardColorList {
            preset
            colorHex
          }
        }
      }
    }
  }
}
`;

/* eslint-disable-next-line import/no-default-export */
export default HOME_QUERY;
